export type ProductPricing = {
  title: string,
  price: string,
  priceId: string,
  benefits: string[],
  isLocal: boolean,
  isAnnual?: boolean,
  displayLoggedIn: boolean,
  displayLoggedOut: boolean,
  paypal_plan_id: string,
}

export const pricing: ProductPricing[] = [
  {
    title: "Free",
    price: "$0",
    priceId: "",
    benefits: [
      "Limited access to AI Excel Bot",
      "5 Formula, Code or Task generation and explaination per month",
      "Access to our Chrome extension",
      "email support",
    ],
    isLocal: true,
    displayLoggedIn: false,
    displayLoggedOut: true,
    paypal_plan_id: '',
  },
  {
    title: "Pro",
    price: "$2.99",
    priceId: process.env.NEXT_PUBLIC_STRIPE_PRO_PLAN_PRICE_ID || '',
    benefits: [
      "Full access to AI Excel Bot",
      "Access to our Chrome extension",
      "Access to our Excel add-in",
      "Unlimited Formula generation per month",
      "Unlimited Formula explanations per month",
      "Unlimited VBA code generations per month",
      "Unlimited VBA code explanations per month",
      "Unlimited Task explanations per month",
      "Priority support",
    ],
    isLocal: false,
    isAnnual: false,
    displayLoggedIn: true,
    displayLoggedOut: true,
    paypal_plan_id: process.env.NEXT_PUBLIC_PAYPAL_PRO_PLAN_ID || '',
  },
  {
    title: "Pro Annual",
    price: "$24.99",
    priceId: process.env.NEXT_PUBLIC_STRIPE_PRO_ANNUAL_PLAN_PRICE_ID || '',
    benefits: [
      "Full access to AI Excel Bot",
      "Access to our Chrome extension",
      "Access to our Excel add-in",
      "Unlimited Formula generation per month",
      "Unlimited Formula explanations per month",
      "Unlimited VBA code generations per month",
      "Unlimited VBA code explanations per month",
      "Unlimited Task explanations per month",
      "Priority support",
    ],
    isLocal: false,
    isAnnual: true,
    displayLoggedIn: true,
    displayLoggedOut: true,
    paypal_plan_id: process.env.NEXT_PUBLIC_PAYPAL_PRO_ANNUAL_PLAN_ID || '',
  },
];

